import * as tslib_1 from "tslib";
import { throwError as observableThrowError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../base.service';
import { Paging } from '../../models/latipay/paging.model';
var WalletAddOnService = /** @class */ (function (_super) {
    tslib_1.__extends(WalletAddOnService, _super);
    function WalletAddOnService(http) {
        var _this = _super.call(this, 'wallet-add-on', http) || this;
        _this.http = http;
        _this.embeddedStr = '';
        return _this;
    }
    WalletAddOnService.prototype.ngOnInit = function () {
    };
    WalletAddOnService.prototype.getAllWalletByPaging = function (searchCondition, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        return this.http.get(this.url + "?" + paging.getPagingStr() + (this.embeddedStr + searchCondition)).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    WalletAddOnService.prototype.getAllByPagingByOrgIdFT = function (orgId, searchCondition, paging, pageNum) {
        var sortStr = '&sort=createDate,desc';
        var embededStr = '&embedded=organisation';
        var str = '&f_organisation.id=' + orgId + '&f_organisation.id_op==';
        paging.pageNumber = pageNum;
        return this.http.get(this.baseUrl + "wallet?" + paging.getPagingStr() + (this.embeddedStr + str + sortStr)).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    WalletAddOnService.prototype.getAllByOrgId = function (orgId) {
        var sortStr = '&sort=createDate,desc';
        var embededStr = '&embedded=organisation';
        var str = '&f_organisation.id=' + orgId + '&f_organisation.id_op==';
        var tempPaging = new Paging({ pageNumber: 1, pageSize: 1000000 });
        return this.http.get(this.baseUrl + "wallet?" + tempPaging.getPagingStr() + (embededStr + sortStr + str)).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    WalletAddOnService.prototype.getAllByWalletId = function (walletId) {
        var str = '&f_walletId=' + walletId;
        var tempPaging = new Paging({ pageNumber: 1, pageSize: 1000000 });
        return this.http.get(this.baseUrl + "wallet-add-on?" + tempPaging.getPagingStr() + str).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    //  /v1/wallet?f_organisation.id=18&f_organisation.id_op==
    WalletAddOnService.prototype.getAllByPagingByOrgId = function (orgId, searchCondition, paging) {
        var sortStr = '&sort=createDate,desc';
        var embededStr = '&embedded=organisation';
        var str = '&f_organisation.id=' + orgId + '&f_organisation.id_op==';
        return this.http.get(this.baseUrl + "wallet?" + paging.getPagingStr() + (this.embeddedStr + str + sortStr)).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    WalletAddOnService.prototype.getAllMaintainWalletsByPagingByOrgId = function (orgId, searchCondition, paging) {
        var sortStr = '&sort=createDate,desc';
        var embededStr = '&embedded=organisation';
        var str = '&f_organisation.id=' + orgId + '&f_organisation.id_op==';
        return this.http.get(this.baseUrl + "wallet/maintain-list?" + paging.getPagingStr() + (this.embeddedStr + str + sortStr)).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    WalletAddOnService.prototype.getAllSpecificByPaging = function (searchCondition, paging) {
        var sortStr = '&sort=createDate,desc';
        var embededStr = '&embedded=organisation';
        return this.http.get(this.baseUrl + "wallet?" + paging.getPagingStr() + (this.embeddedStr + searchCondition + sortStr)).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    WalletAddOnService.prototype.saveWallet = function (payeaseType, isOnline, bankAccountId, merchantUserId, value) {
        var embededStr = '&embedded=organisation,primary-currency';
        return this.http.post(this.url + "?merchantUserId=" + merchantUserId + "&payeaseType=" + payeaseType + "&isOnline=" + isOnline + "&bankAccountId=" + bankAccountId + this.embeddedStr, value).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    WalletAddOnService.prototype.generateDefault = function (value) {
        return this.http.post(this.url + "/generate-default", value).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    WalletAddOnService.prototype.getAllSubMchID = function (id) {
        return this.http.post(this.url + "/get-wechat-id/" + id, '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    WalletAddOnService.prototype.verifyWallet = function (code) {
        return this.http.post(this.url + "/" + code + "/verify", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    WalletAddOnService.prototype.updateWallet = function (payeaseType, isOnline, bankAccountId, id, value) {
        var embededStr = '&embedded=organisation,primary-currency';
        return this.http.put(this.url + "/" + id + "?payeaseType=" + payeaseType + "&isOnline=" + isOnline + "&bankAccountId=" + bankAccountId + this.embeddedStr, value).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    WalletAddOnService.prototype.adjustWalletBalance = function (id, value) {
        return this.http.put(this.url + "/adjust/" + id, value).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    WalletAddOnService.prototype.updateAccountName = function (id, value) {
        return this.http.put(this.url + "/update-name/" + id, value).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    WalletAddOnService.prototype.disableWallet = function (id, value) {
        return this.http.put(this.url + "/disable/" + id, value).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    WalletAddOnService.prototype.getAllWalletByOpenIds = function (openIds, paging) {
        var openIdsStr = '';
        if (openIds) {
            openIds.forEach(function (openId) {
                openIdsStr += "&openid=" + openId;
            });
        }
        return this.http.get(this.url + "/openids?" + paging.getPagingStr() + openIdsStr);
    };
    return WalletAddOnService;
}(BaseService));
export { WalletAddOnService };
